import { USERS_LIST_GROUPS_COLLAPSE_THRESHOLD } from '../../dashboard/constants';

import linkedPositionsUrl from './linkedPositions.html';

class LinkedPositionsCtrl {
  constructor($scope, $timeout) {
    'ngInject';

    Object.assign(this, { $scope, $timeout });
  }

  toggle =
    (state) =>
    (trigger = true) => {
      this.shouldShowAll = state;
      if (trigger) {
        this.$timeout(() => {
          this.$scope.$emit('vsRepeatTrigger');
        });
      }
    };

  $onInit() {
    this.displayedItemsLimit = USERS_LIST_GROUPS_COLLAPSE_THRESHOLD;

    this.showAll = this.toggle(true);
    this.showLess = this.toggle(false);

    this.showLess(false);
  }
}

export default {
  controller: LinkedPositionsCtrl,
  controllerAs: 'ctrl',
  templateUrl: linkedPositionsUrl,
  bindings: {
    src: '=',
    comma: '=?',
    shouldShowAll: '=isExpanded',
  },
};
